import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateImageResponse, CreateImageWithRepositoryResponse } from 'src/app/core/models/repository';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';

@Component({
  selector: 'app-build-image',
  templateUrl: './build-image.component.html',
  styleUrl: './build-image.component.scss'
})
export class BuildImageComponent implements OnInit {
  
  constructor(
    public dialog: MatDialogRef<BuildImageComponent>,
    private configEntityService: ConfigEntityService,
    private snackBar: MatSnackBar,
    private myElement: ElementRef,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: { 
      name: string, 
      updateForm: boolean,
      isBuildAndPush: boolean
    }
  ) { }
  
  buildImageFormVar: UntypedFormGroup;
  buildAndPushImageFormVar: UntypedFormGroup;
  isBuildAndPush: boolean = this.data.isBuildAndPush;
  
  ngOnInit(): void {
    this.buildAndImageAndPushForm();
  }
  
  buildAndImageAndPushForm() {
    this.buildAndPushImageFormVar = new UntypedFormGroup({
      image_name: new UntypedFormControl('', Validators.required),
      dockerfile_content: new UntypedFormControl('FROM alpine:latest\nRUN apk add --no-cache curl\nCMD ["echo", "Hello World"]', Validators.required),
      registry_host: new UntypedFormControl(''),
      repository_name: new UntypedFormControl(''),
      tag: new UntypedFormControl('latest', Validators.required),
      auto_push: new UntypedFormControl(false)
    });
  }
  
  onCancel() {
    this.dialog.close(false);
  }
  
  toogleDialog: boolean = false;
  toogleDialogMinMax() {
    this.toogleDialog = !this.toogleDialog;
    const currentElement = this.myElement.nativeElement;
    let dialogElement = currentElement.parentElement;
    while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
      dialogElement = dialogElement.parentElement;
    }
    if (!dialogElement) {
      console.error('Could not find parent overlay pane');
      return;
    }
    if(this.toogleDialog) {
      dialogElement.classList.add('minimize2');
      dialogElement.classList.remove('maximize');
    } else {
      dialogElement.classList.remove('minimize2');
      dialogElement.classList.add('maximize');
      setTimeout(() => {
        dialogElement.classList.remove('maximize');
      }, 300);
    }
  }
  
  createImage() {
    try{
      this.spinner.show();
      if (!this.buildAndPushImageFormVar.valid) {
        this.buildAndPushImageFormVar.markAllAsTouched();
        this.snackBar.open('Please fill in all required fields.', 'Close', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        return;
      }

      const formValue = this.buildAndPushImageFormVar.getRawValue();

      const request = {
        dockerfile_content: formValue.dockerfile_content,
        image_name: formValue.image_name + ":" + formValue.tag || 'latest',
        tag: formValue.tag || 'latest',
      };
      this.configEntityService.createImage(request).subscribe({
        next: (response) => {
          this.spinner.hide();
          let createImageResponse: CreateImageResponse = JSON.parse(JSON.stringify(response));
          if (createImageResponse) {
            if (createImageResponse.message) {
              this.snackBar.open(createImageResponse.message, 'Close', {
                duration: 5000,
                panelClass: ['success-snackbar']
              });
            }
          }
          this.dialog.close(createImageResponse);
        },
        error: (error) => {
          this.spinner.hide();
          this.snackBar.open('Failed to build image. Please try again.', 'Close', {
            duration: 5000,
            panelClass: ['error-snackbar']
          });
        }
      });
    }
    catch (error) {
      this.spinner.hide();
      this.snackBar.open('Failed to create image. Please try again.', 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
      return;
    }
  }

}
